import { useDispatch, useSelector } from 'react-redux'
import { useLocalization } from '../../../Hooks/useLocalization'
import './LoggingList.scss'
import { TextInput } from '../../../Components/TextInput/TextInput'
import { type RootState } from '../../../Store/Store'
import { useEffect, useMemo, useState } from 'react'
import { TableList } from '../../../Components/TableList/TableList'
import { setIsLoggingsRequested } from '../../../Store/DataSlice'
import { sortResultNumber } from '../../../Utils/Arrays'

const localizationSection = 'logging-list'
export function LoggingList() {
  const dispatch = useDispatch()
  const localization = useLocalization(localizationSection)

  useEffect(() => {
    dispatch(setIsLoggingsRequested(true))
  }, [dispatch])

  const allLoggings = useSelector((state: RootState) => state.data.loggings)
  const [filterEmail, setFilterEmail] = useState('')
  const [filterAction, setFilterAction] = useState('')

  const filteredLoggings = useMemo(() => {
    return allLoggings
      .filter((c) => {
        if (
          filterEmail &&
          !c.userEmail.toLowerCase().includes(filterEmail.toLowerCase())
        )
          return false
        if (
          filterAction &&
          !c.action.toLowerCase().includes(filterAction.toLowerCase())
        )
          return false
        return true
      })
      .sort((a, b) => sortResultNumber(a.changeDate, b.changeDate) * -1)
  }, [allLoggings, filterAction, filterEmail])

  return (
    <div className="logging-list">
      <div className="filters">
        <div className="filter-field">
          <TextInput
            label={localization.text('filter-email-input-label', 'Email')}
            helperText={localization.text(
              'filter-email-input-helper',
              'Geef (een deel van) het email address van de gebruiker in'
            )}
            value={filterEmail}
            onChange={setFilterEmail}
          />
        </div>
        <div className="filter-field">
          <TextInput
            label={localization.text('filter-action-input-label', 'Action')}
            helperText={localization.text(
              'filter-action-input-helper',
              'Geef (een deel van) actie in'
            )}
            value={filterAction}
            onChange={setFilterAction}
          />
        </div>
      </div>
      <TableList
        tableType="logging"
        items={filteredLoggings}
        configurations={{
          uuid: {
            label: 'Uuid',
            show: false,
          },
          changeDate: {
            label: 'Datum',
            show: true,
            getValue: (value) => new Date(value as number).toLocaleString(),
            getSortValue: (value) =>  value as number,
            getCsvExportValue: (value) =>
              value != null ? new Date(value as number).toISOString() : '',
            getExcelExportValue: (value) =>
              value != null ? new Date(value as number) : undefined,
          },
          userEmail: {
            label: 'Email',
            show: true,
          },
          action: {
            label: 'Actie',
            show: true,
          },
          details: {
            label: 'Details',
            show: true,
            getValue: (value) => (value != null ? JSON.stringify(value) : ''),
          },
        }}
        localizationSection={localizationSection}
        getUniqueKey={(item) => item.uuid}
        isLoading={allLoggings.length === 0}
      />
    </div>
  )
}
